/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

/**
 * Normalises a raw battery charge value to a 0..100 percentage, so that every consumer (the ECM diagnostics
 * panel and the map balloon) approximates the battery the same way.
 *
 * A value within the inclusive 0..1 range is treated as a fraction and converted to a percentage rounded to
 * the nearest integer (e.g. 0.49067065 => 49, 0.89 => 89). A value outside that range is assumed to already be
 * a percentage and is returned unchanged (e.g. 50 => 50). Non-finite values are returned unchanged.
 */
export function normalizeBatteryPercentage(value: number): number {
  if (!Number.isFinite(value) || value < 0 || value > 1) {
    return value;
  }
  return Math.round(value * 100);
}
